<template>
  <b-modal id="updateDescriptionModal" ref="updateDescriptionModal" size="xs" hide-footer @hidden="$emit('reset')">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('views.excmcalllog.list.setDescription') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{ $t('views.excmcalllog.list.setDescription') }}:</label><br>
          <input v-model="updateDescription.description" name="advanceDescription" type="text" autofocus :placeholder="$t('views.excmcalllog.list.setDescription')" class="form-control" id="advanceDescription"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn float-left btn-info mr-1" @click="updateItem()">{{ $t('buttons.submit') }}</b-button>
        <b-button class="btn float-left btn-danger" @click="hideModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import ApiService from '@/utils/ApiService'
export default {
  name: 'updateDescriptionModal',
  props: {
    updateDescription: {}
  },
  mounted () {
    if (this.updateDescription) {
      this.$refs.updateDescriptionModal.show()
    }
  },
  methods: {
    hideModal () {
      this.$refs.updateDescriptionModal.hide()
      this.$emit('reset')
    },
    resetUpdateDescription () {
      this.$emit('reset', true)
    },
    async updateItem () {
      const response = await new ApiService(this.updateDescription['@id']).put(this.updateDescription)
      if (response.status === 200) {
        this.resetUpdateDescription()
      }
    }
  }
}
</script>
